export enum ScoreCardMetricKey {
  totalPrincipalAmount = 'totalPrincipalAmount',
  totalLoansNumber = 'totalLoansNumber',
}
